<template lang="pug">
  apollo-query(
    :query="query"
    :variables="{ id: studentId }"
    :fetchPolicy="fetchPolicy"
    @result="onResult")
    template(slot-scope="{ result: { loading, error, data } }")
      slot(
        :unsentCurriculums="curriculums"
        :student="student") Implement required
</template>

<script>
import { FETCH_UNSENT_CURRICULUMS_QUERY } from '@/graphql'
import createCurriculum from '@/entities/Curriculum'
import createStudent from '@/entities/Student'

export default {
  props: {
    studentId: { type: String },
    fetchPolicy: { type: String, default: 'cache-first' },
  },
  data() {
    return {
      query: FETCH_UNSENT_CURRICULUMS_QUERY,
      curriculums: [],
      student: {},
    }
  },
  methods: {
    onResult(result) {
      const edge = result.data.currentUser.contractedStudents.edges[0]
      if (edge) {
        this.curriculums = edge.node.student.unsentCurriculums.edges.map((e) =>
          createCurriculum(e.node)
        )
        this.student = createStudent(edge.node.student)
      } else {
        this.curriculums = []
        this.student = {}
      }
    },
  },
}
</script>
